__turbopack_context__.v({
  "body": "CourseLevelSection-module__zA2i6q__body",
  "bodyWithFooter": "CourseLevelSection-module__zA2i6q__bodyWithFooter",
  "header": "CourseLevelSection-module__zA2i6q__header",
  "optionCard": "CourseLevelSection-module__zA2i6q__optionCard",
  "optionCardDescription": "CourseLevelSection-module__zA2i6q__optionCardDescription",
  "section": "CourseLevelSection-module__zA2i6q__section",
});
